module.exports = __webpack_public_path__ + "img/product-shot_06.95f3bbf3.jpg";